import React, { useEffect, useState, useRef } from 'react'
import { Modal } from 'react-bootstrap';
import {
    getProcessButtons, getError, isUndNullEmpNew, sendMessageCloseCurrentWindow, setBadgeStatusGeneric, settings, getResponse, getLanguageObj
} from '../../helpers/UtilsHelper';
import HtmlParser from 'react-html-parser';
import { GlobalFormats } from '../../classes/main/globalFormatClass';
import { AuthContextType } from '../../auth/AuthContext';
import { BotService } from '../../services/bots/BotService';

const { icons, labels, messages } = settings
const currentMethod = 'BotAdd - function';

export default function BotAdd({
    processValues,
    languageObj = GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
} = {}) {
    //#region variables
    const {
        $ = {},
        auth = AuthContextType,
        dtId = '',
        type = 0,
        showModal = false,
        setShowModal = () => { },
        bot = {},
        setBot = () => { },
        modules = [],
        setModules = () => { },
        events = [],
        setEvents = () => { },
        moduleEvents = [],
        setModuleEvents = () => { },
        textAreaAnswerId = '',
    } = processValues;

    const [errors, setErrors] = useState({
        name: '',
        moduleId: '',
        eventId: '',
    });

    const [process, setProcess] = useState({
        showLoading: false,
        save: false,
    });

    const isMount = useRef(true);
    //#endregion variables

    //#region methods
    const setDefaultValue = ({
        isModalClose = false,
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setDefaultValue';
        let response = getResponse({ type: 0 });
        try {
            setErrors({ name: '', moduleId: '', eventId: '' });
            if (isModalClose) {
                setBot({});
                setShowModal(!isModalClose);
            }
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
            console.log(response);
        }
    };

    const addBotPost = async ({
        e = {},
        subMethod = '',
    } = {}) => {
        const currentMethod = 'addBotPost';
        let response = getResponse({ type: 0 });
        try {
            e?.preventDefault?.();

            response = formDataValidate({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;

            setProcess(prev => ({ ...prev, showLoading: true, save: true }));

            // const token = auth?.account?.tokenVzLaML?.token;
            // const headers = {
            //     authorization: `bearer ${token}`,
            // };

            response = await BotService?.createBot({
                token: auth?.account?.tokenVzLaML?.token,
                data: bot,
                subMethod: currentMethod,
            });
            if (!response?.isSuccess || response?.isWarning) return;

            const bot_ = response?.result?.bot;
            // bot = botLocal;
            setBot(bot_);
            const events_ = response?.result?.events || [];
            setEvents(events_);
            const modules_ = response?.result?.modules || [];
            setModules(modules_);

            const dtRow = [
                bot_.name,
                modules_.filter(({ id, }) => id === bot_.moduleId)?.[0]?.name?.[languageObj?.id],
                events_.filter(({ id, }) => id === bot_.eventId)?.[0]?.name?.[languageObj?.id],
                setBadgeStatusGeneric({
                    type: (bot_.status ? 0 : 1),
                    value: (bot_.status ? labels?.enabled?.[languageObj?.id] : labels?.disabled?.[languageObj?.id])
                }),
                getProcessButtons({
                    id: bot_.id,
                    description: bot_.name,
                    detailsShow: false,
                    detailsLabel: labels?.detail?.[languageObj?.id],
                    detailsEnabled: false,
                    editShow: true,
                    editLabel: labels?.edit?.[languageObj?.id],
                    editEnabled: true,
                    deleteShow: true,
                    deleteLabel: labels?.delete?.[languageObj?.id],
                    deleteEnabled: true,
                    processButtons: [],
                    languageId: languageObj?.id,
                    subMethod: currentMethod
                })?.result
            ];

            $(`#${dtId}`).DataTable().row.add(dtRow).draw();

            response.msgText = `${messages?.processCompletedSuccessfully?.[languageObj?.id]}<br/>`;
            response.msgText += `${messages?.rememberToEnableTheBotAndAddMessageAccordingToItsFunction?.[languageObj?.id]}<br/>`;
            response.msgText += `${messages?.toDoThisYouMustEditTheInformation?.[languageObj?.id]}`;
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, showLoading: false, save: false }));

            if (response?.isSuccess && !response?.isWarning) {
                setDefaultValue({
                    isModalClose: true,
                    subMethod: currentMethod,
                });
            }

            await sendMessageCloseCurrentWindow({
                response: response,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    };

    const formDataValidate = ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'formDataValidate';
        let response = getResponse({ type: 0 });
        try {
            const thisFieldRequired = messages?.thisFieldRequired?.[languageObj?.id];
            const errors_ = { name: '', moduleId: '', eventId: '' };

            if (isUndNullEmpNew({ data: bot?.name, subMethod: currentMethod })?.result) {
                errors_.name = thisFieldRequired;
                response = getResponse({ type: 1 });
            }

            if (isUndNullEmpNew({ data: bot?.moduleId, subMethod: currentMethod })?.result) {
                errors_.moduleId = thisFieldRequired;
                response = getResponse({ type: 1 });
            }

            if (isUndNullEmpNew({ data: bot?.eventId, subMethod: currentMethod })?.result) {
                errors_.eventId = thisFieldRequired;
                response = getResponse({ type: 1 });
            }

            setErrors(errors_);

            if (response?.isWarning) {
                response.isSuccess = false;
            }
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    };

    const setFormValue = ({
        key = '',
        value = '',
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setFormValue';
        let response = getResponse({ type: 0 });
        try {
            switch (key) {
                case 'order':
                    setBot(prev => ({
                        ...prev,
                        [key]: isUndNullEmpNew({ data: value, subMethod: currentMethod, })?.result || isNaN(value) ? 1 : parseInt(value),
                    }));
                    break;
                case 'moduleId':
                    setModuleEvents(events.filter(({ moduleId }) => moduleId === value));
                    setBot(prev => ({ ...prev, [key]: value, eventId: '', message: '' }));
                    break;
                case 'eventId':
                    setBot(prev => ({ ...prev, [key]: value, message: '' }));
                    break;
                default:
                    setBot(prev => ({ ...prev, [key]: value }));
                    break;
            }

            if (key === 'name' && value !== '') {
                setErrors(prev => ({ ...prev, name: '' }));
            }
            if (key === 'moduleId' && value !== '') {
                setErrors(prev => ({ ...prev, moduleId: '' }));
            }
            if (key === 'eventId' && value !== '') {
                setErrors(prev => ({ ...prev, eventId: '' }));
            }

            if (key === 'moduleId' || key === 'eventId') {
                $(`#${textAreaAnswerId}`).val('');
                $(`#${settings.mercadoLibre.objects.html.bots.messageHideId}`).val('');
                $(`#${settings.mercadoLibre.objects.html.bots.messageHideId}`).trigger('click');
            }
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    };

    const getData = async ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'getData';
        let response = getResponse({ type: 0 });
        try {
            if (showModal) {
                if (!isUndNullEmpNew({ data: bot, subMethod: currentMethod })?.result &&
                    !isUndNullEmpNew({ data: bot?.moduleId, subMethod: currentMethod })?.result) {
                    setModuleEvents(events.filter(({ moduleId }) => moduleId === bot.moduleId));
                }

                setErrors({
                    name: '',
                    moduleId: '',
                    eventId: '',
                });
            }
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        } finally {
            if (!response?.isSuccess || response?.isWarning) {
                setShowModal(false);
            }

            await sendMessageCloseCurrentWindow({
                response: response,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    };

    useEffect(() => {
        isMount.current = true;
        getData({
            subMethod: 'form - onLoad',
        });
        return () => { isMount.current = false; };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods

    return (
        <Modal backdrop='static'
            onHide={() => setDefaultValue({ isModalClose: true, subMethod: 'btnModalClose' })}
            show={showModal}
            contentClassName='border-0 shadow-lg login-card'>
            <Modal.Header closeButton className='bg-white border-bottom-0 pt-4 px-4 align-items-center'>
                <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                    style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <img alt='botLogo' src={settings?.images?.icons?.bot} style={{ width: '20px', height: '20px', objectFit: 'contain' }} />
                </div>
                <div className='d-flex flex-column'>
                    <span className='h5 mb-0 font-weight-bold text-dark'>{labels?.bot?.[languageObj?.id] || 'Bot'}</span>
                    <div className='d-flex align-items-center mt-1'>
                        <span className={`badge badge-pill py-1 px-2 text-uppercase ${type === 0 ? 'badge-info' : 'badge-warning text-dark'}`}
                            style={settings?.html?.badges?.micro}>
                            {type === 0 ? labels?.add?.[languageObj?.id] : labels?.edit?.[languageObj?.id]}
                        </span>
                    </div>
                </div>
            </Modal.Header>

            <form onSubmit={(e) => type === 0 ? addBotPost({ e, subMethod: 'onSubmit - form' }) : e.preventDefault()}>
                <Modal.Body className='px-4 pt-2'>
                    {/* Add / edit */}
                    {type === 0 || type === 1 ? (
                        <>
                            <div className='form-group mb-4'>
                                <label className='small font-weight-bold text-uppercase form-label-uppercase mb-2'>
                                    {labels?.name?.[languageObj?.id]}
                                </label>
                                <div className='position-relative'>
                                    <i className={`${icons?.fasFa?.spellCheck} position-absolute input-icon-left`} />
                                    <input className='form-control border-0 shadow-sm form-input-icon'
                                        title={labels?.name?.[languageObj?.id]}
                                        type='text'
                                        onChange={(e) => setFormValue({ key: 'name', value: e.target.value, subMethod: 'inputName' })}
                                        onFocus={() => setErrors(prev => ({ ...prev, name: '' }))}
                                        placeholder={labels?.name?.[languageObj?.id]}
                                        value={bot?.name || ''}
                                        disabled={process?.showLoading} />
                                </div>
                                {errors?.name && <div className={settings?.html?.errorText}>{HtmlParser(errors?.name || '')}</div>}
                            </div>

                            <div className='form-group mb-4'>
                                <label className='small font-weight-bold text-uppercase form-label-uppercase mb-2'>
                                    {labels?.module?.[languageObj?.id]}
                                </label>
                                <div className='position-relative'>
                                    <i className={`${icons?.fasFa?.listUl} position-absolute input-icon-left`} />
                                    <select className='form-control border-0 shadow-sm form-input-icon custom-select-premium'
                                        value={bot?.moduleId || ''}
                                        onChange={(e) => setFormValue({ key: 'moduleId', value: e.target.value, subMethod: 'selectModules' })}
                                        onFocus={() => setErrors(prev => ({ ...prev, moduleId: '' }))}
                                        placeholder={labels?.module?.[languageObj?.id]}
                                        title={labels?.module?.[languageObj?.id]}
                                        disabled={process?.showLoading}>
                                        <option key='nothing' value=''>{messages?.selectMethod?.[languageObj?.id]}</option>
                                        {modules.map((detail) => <option key={detail.id} value={detail.id}>{detail.name?.[languageObj?.id]}</option>)}
                                    </select>
                                </div>
                                {errors?.moduleId && <div className={settings?.html?.errorText}>{HtmlParser(errors?.moduleId || '')}</div>}
                            </div>

                            <div className='form-group mb-4'>
                                <label className='small font-weight-bold text-uppercase form-label-uppercase mb-2'>
                                    {labels?.event?.[languageObj?.id]}
                                </label>
                                <div className='position-relative'>
                                    <i className={`${icons?.fasFa?.listOl} position-absolute input-icon-left`} />
                                    <select className='form-control border-0 shadow-sm form-input-icon custom-select-premium'
                                        value={bot?.eventId || ''}
                                        onChange={(e) => setFormValue({ key: 'eventId', value: e.target.value, subMethod: 'selectEvents' })}
                                        onFocus={() => setErrors(prev => ({ ...prev, eventId: '' }))}
                                        placeholder={labels?.event?.[languageObj?.id]}
                                        title={labels?.event?.[languageObj?.id]}
                                        disabled={process?.showLoading}>
                                        <option key='nothing' value=''>{messages?.selectEvent?.[languageObj?.id]}</option>
                                        {moduleEvents.map((detail) => <option key={detail.id} value={detail.id}>{detail.name?.[languageObj?.id]}</option>)}
                                    </select>
                                </div>
                                {errors?.eventId && <div className={settings?.html?.errorText}>{HtmlParser(errors?.eventId || '')}</div>}
                            </div>
                        </>
                    ) : (
                        <></>
                    )}
                </Modal.Body>

                <Modal.Footer className='border-top-0 pb-4 px-4 bg-white'>
                    <div className='d-flex justify-content-center w-100'>
                        <button className='btn btn-primary shadow-sm font-weight-bold mx-1 px-4 btn-primary'
                            data-title={labels?.save?.[languageObj?.id]}
                            disabled={process?.showLoading}
                            type='submit'>
                            {!process?.save ? (
                                <i className={`${icons?.fasFa?.save} mr-1`} />
                            ) : (
                                <span className={settings?.react?.html?.spinner?.borderSm} role='status' aria-hidden='true'></span>
                            )} {labels?.save?.[languageObj?.id]}
                        </button>
                        <button className='btn btn-light border shadow-sm font-weight-bold mx-1 px-4 text-secondary btn-general'
                            data-title={labels?.close?.[languageObj?.id]}
                            type='button'
                            disabled={process?.showLoading}
                            onClick={() => setDefaultValue({ isModalClose: true, subMethod: 'btnModalFooterClose' })}>
                            <i className={`${icons?.fasFa?.arrowAltCircleLeft} mr-1`} /> {labels?.close?.[languageObj?.id]}
                        </button>
                    </div>
                </Modal.Footer>
            </form>
        </Modal>
    );
}